import BeddingSectionStack from './BeddingSectionStack';

export default BeddingSectionStack;
